import React from "react";
import Header from "../../../Components/Header/Header";
import { useState, useEffect } from "react";
import CheckingDetails from "./CustomEventDetails/CheckingDetails";
import HostDetails from "./CustomEventDetails/HostDetails";
import MediaDetails from "./CustomEventDetails/MediaDetails";
import { useLocation } from "react-router-dom";
import { apiCallGetEventDetails } from "../../../Core/Apicall";
import { useDispatch } from "react-redux";
import {
  setLoadingFalse,
  setLoadingTrue,
} from "../../../Config/Actions/loadingActions";
import AttendDetails from "./CustomEventDetails/AttendDetails";
import CheckedEvent from "./CustomEventDetails/CheckedEvent";
import BookedTickets from "./CustomEventDetails/BookedTicket";
import MasterEventChange from "./CustomEventDetails/MasterEventChange";

function EventDetails() {
  const location = useLocation();
  const [activeTab, setActiveTab] = useState(0);
  const [eventDetails, setEventDetails] = useState([]);
  const [hostDetails, setHostDetails] = useState();
  const tabs = [
    "Host Details",
    "Media Details",
    "Attend In Details",
    "Checked In Details",
    "Booked Tickets Details",
    location?.state?.isMasterEvent && "Master Events",
  ];
  const dispatch = useDispatch();
  const handleTabClick = (index) => {
    setActiveTab(index);
  };
  useEffect(() => {
    if (location.state) {
      onApiCallUserDetails();
    }
  }, []);

  const onDeleteMedia = async (data) => {
    setHostDetails((prev) => ({
      ...prev,
      eventMedia: prev.eventMedia.filter((media) => media._id !== data._id),
    }));
  };

  const onApiCallUserDetails = async () => {
    dispatch(setLoadingTrue());
    const param = {
      eventId: location.state.eventId,
    };
    try {
      const response = await apiCallGetEventDetails(param);
      setEventDetails(response);
      setHostDetails(response.data);
      dispatch(setLoadingFalse());
    } catch (error) {
      dispatch(setLoadingFalse());
    }
  };
  return (
    <div>
      <Header name="Event Details" />
      <div className="user-profile-custom-container margin-top-20">

        {tabs.map((tab, index) => (
          <div
            key={index.toString()}
            style={{
              padding: "10px",
              fontWeight: "400",
              color: index != activeTab ? "rgba(255, 255, 255, 0.5)" : " #fff",
              borderBottom: index != activeTab ? "" : "1px solid #fff",
            }}
            className="fontSize18 pointer"
            onClick={() => handleTabClick(index)}
          >

            {tab}
          </div>
        ))}
      </div>

      <div className="margin-top-20">
        {activeTab === 0 && (
          <div className="grid grid-cols-2 gap-7">
            <HostDetails eventDetails={eventDetails?.data} />
          </div>
        )}
        {activeTab === 1 && (
          <div className="grid grid-cols-2 gap-7">
            <MediaDetails
              mediaDetalisData={hostDetails.eventMedia}
              onDeleteMedia={(data) => onDeleteMedia(data)}
            />
          </div>
        )}
        {activeTab === 2 && (
          <div className="grid grid-cols-2 gap-7">
            <AttendDetails eventId={location.state.eventId} />
          </div>
        )}
        {activeTab === 3 && (
          <div className="grid grid-cols-2 gap-7">
            <CheckedEvent eventId={location.state.eventId} />
          </div>
        )}
        {activeTab === 4 && (
          <div className="grid grid-cols-2 gap-7">
            <BookedTickets eventId={location.state.eventId} />
          </div>
        )}

        {/* {activeTab === 3 && (
          <div className="grid grid-cols-2 gap-7">
            <CheckingDetails eventDetails={eventDetails?.data} />
          </div>
        )} */}


        {activeTab === 5 && (
          <MasterEventChange eventId={location.state.eventId} />
        )}
      </div>
    </div>
  );
}
export default EventDetails;
